import { useParams } from "react-router";
import { Button, ConditionalTooltip } from "../../../../../../components";
import { isAdmin } from "../../../../../../utils";
import { useGridRowsContext, useSaveLayout } from "../../hooks";
import { getIsEnabled } from "./utils";

const admin = isAdmin();

type Props = {
  disabled?: boolean;
  onClick?: () => void;
};

const getTooltipMessage = (type?: string) => {
  if (!admin && type === "shared")
    return "You're not allowed to modify shared layouts.";
  return "You can't overwrite the ReversingLabs default layout.";
};

const SaveButton = ({ disabled, onClick }: Props) => {
  const { id, type } = useParams();

  const { save } = useSaveLayout();
  const { canvasRows } = useGridRowsContext();

  const handleSave = () => {
    if (!id || !type) return;
    onClick?.();
    save({ id, type, content: canvasRows });
  };

  const isEnabled = getIsEnabled(admin, type);

  const showTooltip = type === "rl" || (type === "shared" && !admin);

  return (
    <ConditionalTooltip
      tooltip={getTooltipMessage(type)}
      condition={showTooltip}
    >
      <div>
        <Button
          data-testid="layout-save-button"
          onClick={handleSave}
          disabled={!isEnabled || disabled}
          variant="primary"
        >
          SAVE
        </Button>
      </div>
    </ConditionalTooltip>
  );
};

export default SaveButton;
